<script>
  import { Row, Col, Button } from "sveltestrap";
</script>

<Row class="text-center h-100">
  <Col class="align-self-center">
    <h2>
      Your chat has been destroyed. Please reload the page to join a new chat.
    </h2>
    <br />
    <Button size="lg" color="primary" on:click={() => window.location.reload()}>
      Reload
    </Button>
  </Col>
</Row>
